module.exports = __webpack_public_path__ + "static/media/WechatIMG50.c17f9935.png";